import React from 'react'
import { Col } from 'react-bootstrap'

const ReusableFeaturedProducts = ({img}) => {
  return (
    <Col lg={4} xs={6} >
      <div class="featured_products_main">
        <div class="featured_products_img">
          <img src={img} class="w-100" alt=""/>
          <div class="featured_products_img_overlaay">
            <div class="icon"><i class="fa-regular fa-heart"></i></div>
             <div class="icon"><i class="fa-solid fa-magnifying-glass"></i></div>
            <div class="icon"><i class="fa-solid fa-arrow-right-arrow-left"></i></div>
            <div class="icon"><i class="fa-solid fa-cart-shopping"></i></div>
          </div>
        </div>
        <div class="featured_products_text ">
          <ul class="icson">
            <li ><i class="fa-solid fa-star"></i></li>
            <li ><i class="fa-solid fa-star"></i></li>
            <li ><i class="fa-solid fa-star"></i></li>
            <li><i class="fa-solid fa-star"></i></li>
            <li ><i class="fa-solid fa-star"></i></li>
          </ul>
          <p>$8.00-9.00</p>
          <h4>Organic Fresh Vegetables</h4>
        </div>
      </div>
    </Col>
  )
}

export default ReusableFeaturedProducts